import { isNotTypeOf } from '../../../utils/primitives';
import * as Result from './result';
export class DependencyResolution {
    constructor(dependencyName) {
        this.dependencyName = dependencyName;
        this.errors = [];
    }
    addIssue(...error) {
        this.errors.push(...error);
        return this;
    }
    result(dependencies) {
        return {
            name: this.dependencyName,
            result: Result.successOrFailure(!this.errors.length)({ [this.dependencyName]: dependencies }),
            errors: this.errors,
        };
    }
}
export class DependencyResolutionError extends Error {
    constructor(dependencyPath, msg, options) {
        const dependencyPathStr = dependencyPath
            .filter(isNotTypeOf('undefined'))
            .map(String)
            .join('.');
        super(`issue resolving "${dependencyPathStr}": ${msg}`, options);
    }
}
//# sourceMappingURL=resolution.js.map